export default "__VITE_ASSET__CrE3dCt___"